/**
* Index.ts
* @author Abhilash Panwar (abpanwar) and Hector Hernandez (hectorh)
* @copyright Microsoft 2018
* File to export public classes, interfaces and enums.
*/
import '@microsoft/applicationinsights-shims';
import { ValueKind, Utils, EventLatency, EventPersistence, TraceLevel, MinChannelPriorty, NotificationManager, EventsDiscardedReason, CoreUtils, DiagnosticLogger, getGlobal } from '@microsoft/1ds-core-js';
import { PropertiesPlugin } from '@microsoft/1ds-properties-js';
import { PostChannel, BE_PROFILE, NRT_PROFILE, RT_PROFILE } from '@microsoft/1ds-post-js';
import { ActionType } from '@microsoft/1ds-wa-js';
import { ApplicationInsights } from './ApplicationInsights';
export { ApplicationInsights, MinChannelPriorty, ValueKind, Utils, EventLatency, EventPersistence, TraceLevel, NotificationManager, PropertiesPlugin, PostChannel, CoreUtils, BE_PROFILE, NRT_PROFILE, RT_PROFILE, EventsDiscardedReason, DiagnosticLogger, ActionType };
(function () {
    //should be global function that should load as soon as SDK loads
    try {
        // E2E sku on load initializes core and pipeline using snippet as input for configuration
        var aiName;
        var global = getGlobal();
        if (global && typeof JSON !== 'undefined') {
            // get snippet or initialize to an empty object
            aiName = global['onedsSDK'] || 'oneDSWeb';
            if (global[aiName] !== undefined) {
                var snippet = global[aiName];
                var ai = new ApplicationInsights();
                ai.updateSnippetDefinitions(snippet);
                ai.initialize(snippet.config, snippet.extensions);
                // Update global instance
                global[aiName] = ai;
                ai.emptySnippetQueue(snippet);
            }
        }
    }
    catch (e) {
        if (console) {
            console.warn('Failed to initialize AppInsights JS SDK for instance ' + aiName + e.message);
        }
    }
})();
//# sourceMappingURL=Index.js.map